import { getToken } from "./auth";

export const getColumn = async (table_name, column_name, options) => {
  const token = getToken();
  const params = [];
  for (const elem in options) {
    console.log(elem, options[elem]);
    params.push(`${elem}=${options[elem]}`);
  }

  // Use the environment variable for the API base URL
  const common_api = process.env.REACT_APP_NODE_SERVICE_BASE_URL;

  // Construct the full URL for the fetch call
  const url = `${common_api}/api/get-column/${table_name}/${column_name}?active=1${
    params.length === 0 ? "" : `&${params.join("&")}`
  }`;

  return await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => res.json())
    .catch((error) => {
      console.error(
        `API call failed for getColumn: ${table_name}/${column_name}`,
        error
      );
    });
};